import { types } from "./actionTypes";
const initialState = {
  getOperationalDashboard: null,
};
const operationalDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_OPERATIONAL_DASHBOARD_SUCCESS:
      state = {
        ...state,
        getOperationalDashboard: action.payload,
      };
      return state;
    default:
      return state;
  }
};
export default operationalDashboardReducer;
